<template>
    <span class="go-back">
        <v-btn color="secondary" large rounded elevation="0" @click="goBack">
            <v-icon left>mdi-arrow-left</v-icon>
            Voltar</v-btn>
    </span>
</template>

<script>
export default {
    methods: {
        goBack() {
            return this.$router.go(-1);
        }
    }
};
</script>

<style scoped>
.go-back{
    display: flex;
    cursor: pointer;
}
button{
    border: 0;
}
</style>
